import { render, staticRenderFns } from "./ResendOrderRoute.vue?vue&type=template&id=416a0a2d&"
import script from "./ResendOrderRoute.vue?vue&type=script&lang=ts&"
export * from "./ResendOrderRoute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports